// extracted by mini-css-extract-plugin
module.exports = {"loader":"CircularProgress_loader__DC8cR","spin":"CircularProgress_spin__RY8bA","track":"CircularProgress_track__s0a95","progress":"CircularProgress_progress__wF36k"};